export var UtilsCommand;
(function (UtilsCommand) {
    UtilsCommand["parseQRCodeString"] = "utils.parse_qr_code_string";
    UtilsCommand["tryParseDSKFromQRCodeString"] = "utils.try_parse_dsk_from_qr_code_string";
    UtilsCommand["num2hex"] = "utils.num2hex";
    UtilsCommand["formatId"] = "utils.format_id";
    UtilsCommand["buffer2hex"] = "utils.buffer2hex";
    UtilsCommand["getEnumMemberName"] = "utils.get_enum_member_name";
    UtilsCommand["rssiToString"] = "utils.rssi_to_string";
    UtilsCommand["guessFirmwareFileFormat"] = "utils.guess_firmware_file_format";
    UtilsCommand["tryUnzipFirmwareFile"] = "utils.try_unzip_firmware_file";
    UtilsCommand["extractFirmware"] = "utils.extract_firmware";
})(UtilsCommand || (UtilsCommand = {}));
